const NotificationEventType = Object.freeze({
    UpdateSensitiveInformation: 'UpdateSensitiveInformation',
});

export default NotificationEventType;
